
import { Vue, Options } from "vue-class-component";
@Options({
  emits: {
    oneexchange: () => {
      return true;
    },
    tenexchange: () => {
      return true;
    }
  }
})
export default class Exchange extends Vue {
  // 是否可兑换幸运码 （星期天不能在兑换幸运码）
  private isExchange = true;
  mounted() {
    const now = new Date();
    /// 是否是星期天
    if (now.getDay() == 0) {
      this.isExchange = false;
    } else {
      this.isExchange = true;
    }
  }
}
